module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/83.c0f404c4.png";